export const GET_UPLOAD_BADGE = "GET_UPLOAD_BADGE";
export const CREATE_UPLOAD_BADGE = "CREATE_UPLOAD_BADGE";
export const UPDATE_UPLOAD_BADGE = "UPDATE_UPLOAD_BADGE";
export const DELETE_UPLOAD_BADGE = "DELETE_UPLOAD_BADGE";

export const OPEN_DIALOGUE_UPLOAD_BADGE = "OPEN_DIALOGUE_UPLOAD_BADGE";
export const CLOSE_DIALOGUE_UPLOAD_BADGE = "CLOSE_DIALOGUE_UPLOAD_BADGE";

export const OPEN_GIVE_UPLOAD_BADGE_DIALOGUE =
  "OPEN_GIVE_UPLOAD_BADGE_DIALOGUE";
export const CLOSE_GIVE_UPLOAD_BADGE_DIALOGUE =
  "CLOSE_GIVE_UPLOAD_BADGE_DIALOGUE";
